import CampaignForm from "./CampaignForm";

import { UpdateCampaignRequest } from "@/types/request/UpdateCampaignRequest";
import { CampaignTypeDTO } from "@/types/response/CampaignType";

type EditCampaignFormProps = {
  campaignId: string;
  campaign: CampaignTypeDTO;
  clientId?: string;
  isSubmitting: boolean;
  onSubmitForm: (payload: UpdateCampaignRequest) => void;
  onSuccess?: () => void;
};

const EditCampaignForm: React.FC<EditCampaignFormProps> = ({
  campaignId,
  campaign,
  clientId,
  isSubmitting,
  onSubmitForm,
  onSuccess,
}) => {
  const handleSubmit = (payload: UpdateCampaignRequest) => {
    onSubmitForm(payload);
  };

  return (
    <CampaignForm 
      type="edit"
      campaign={campaign}
      campaignId={campaignId}
      clientId={clientId}
      isSubmitting={isSubmitting}
      onSubmitForm={handleSubmit}
      onSuccess={onSuccess}
    />
  );
};

export default EditCampaignForm;
